import React from "react";
import { Eye } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import { tenantSiteUrl } from "@/lib/tenantHost";

export default function BrandingPreview({ branding, tenant }) {
  const t = useT("admin");
  return (
    <div className="sticky top-6 bg-white rounded-2xl border border-eh-border-soft p-6">
      <h3 className="text-sm font-medium mb-3 flex items-center gap-2"><Eye className="w-4 h-4" /> {t("brand.preview")}</h3>
      <div
        className="rounded-2xl p-6 mb-4"
        style={{ background: branding.primary_color, color: branding.secondary_color }}
      >
        {branding.logo_url && <img src={branding.logo_url} alt="logo" className="h-10 w-10 mb-3 object-contain" />}
        <div className="text-2xl font-semibold mb-1" style={{ color: "#fff" }}>{tenant?.name || t("brand.myClinic")}</div>
        <div className="text-sm" style={{ color: branding.accent_color }}>{branding.tagline || t("brand.taglineHere")}</div>
        <button
          className="mt-4 px-4 py-2 rounded-full text-sm font-medium"
          style={{ background: branding.accent_color, color: branding.primary_color }}
        >
          {t("brand.book")}
        </button>
      </div>
      <a
        href={tenantSiteUrl(tenant) || `/t/${tenant?.slug || ""}`}
        target="_blank"
        rel="noreferrer"
        className="block text-center text-xs text-eh-sage-deep hover:underline"
      >
        {t("brand.viewFullSite")}
      </a>
    </div>
  );
}
